import React           from 'react';
import styled          from 'styled-components';
import Logo            from '@assets/Logo.svg';
import { Button }      from '@components/index';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { INavItem }    from '../../utils/navigation';

const HeaderMenuWrapper = styled.div`
  display     : flex;
  align-items : flex-end;
  width       : 100%;
`;

const HeaderLogo = styled(Logo)`
  && {
    /* width  : auto; */
    height : 32px;
    cursor : pointer;

    @media (min-width: 960px) {
      height: 56px;
    }
  }
`;

const StyledButton = styled(Button)`
  && {
    margin-left: auto;
  }
`;

interface IProps {
  history      : {
    push: (path: string) => void;
  };
  breadcrumbs? : INavItem[];
  isAuthorized : boolean;
  handleLogout : () => void;
  handleGoHome : () => void;
}

export const HeaderMenu = ({
  history: {
    push,
  },
  breadcrumbs,
  isAuthorized,
  handleLogout,
  handleGoHome,
}: IProps): JSX.Element => (
  <HeaderMenuWrapper>
    <HeaderLogo onClick={handleGoHome} />

    <Breadcrumbs
      push         = {push}
      breadcrumbs  = {breadcrumbs}
      handleGoHome = {handleGoHome}
    />

    {isAuthorized && (
      <StyledButton
        margin  = "0"
        variant = "text"
        label   = "Logout"
        onClick = {handleLogout}
      />
    )}
  </HeaderMenuWrapper>
);
